'use client'

import {useEffect} from 'react'

const debugEvents = [
    'pointerdown',
    'pointerup',
    'pointercancel',
    'click',
    'focusin',
    'focusout',
    'beforeinput',
    'input',
] as const
const pointerDebugBuildEnabled = process.env.NEXT_PUBLIC_POINTER_DEBUG_ENABLED === 'true'

function describeElement(target: EventTarget | null) {
    if (!(target instanceof Element)) {
        return null
    }

    return {
        tagName: target.tagName.toLowerCase(),
        role: target.getAttribute('role') || undefined,
        className: target.getAttribute('class') || undefined,
    }
}

function isFitroDevHost(hostname: string) {
    return hostname === 'fitrodev.pl' || hostname.endsWith('.fitrodev.pl')
}

export function isPointerDebugEnabled(
    hostname: string,
    configuredValue = pointerDebugBuildEnabled,
) {
    return configuredValue && isFitroDevHost(hostname.toLowerCase())
}

export function PointerDebugLogger() {
    useEffect(() => {
        if (!isPointerDebugEnabled(window.location.hostname)) {
            return
        }

        const handleEvent = (event: Event) => {
            const isPointerEvent = typeof PointerEvent !== 'undefined' && event instanceof PointerEvent
            const isInputEvent = typeof InputEvent !== 'undefined' && event instanceof InputEvent

            console.info('[fitro:pointer-debug]', {
                type: event.type,
                defaultPrevented: event.defaultPrevented,
                pointerType: isPointerEvent ? event.pointerType : undefined,
                pointerId: isPointerEvent ? event.pointerId : undefined,
                button: isPointerEvent ? event.button : undefined,
                buttons: isPointerEvent ? event.buttons : undefined,
                isPrimary: isPointerEvent ? event.isPrimary : undefined,
                inputType: isInputEvent ? event.inputType : undefined,
                target: describeElement(event.target),
                activeElement: describeElement(document.activeElement),
            })
        }

        debugEvents.forEach((eventName) => {
            document.addEventListener(eventName, handleEvent, true)
        })

        return () => {
            debugEvents.forEach((eventName) => {
                document.removeEventListener(eventName, handleEvent, true)
            })
        }
    }, [])

    return null
}
